export function hasModuleRestriction(purchase) {
  return Array.isArray(purchase?.unlocked_module_ids) && purchase.unlocked_module_ids.length > 0;
}

export function normalizeModuleIds(ids) {
  if (!Array.isArray(ids)) return [];
  return ids.map((module) => String(module?._id || module));
}

export function isFreeCheckout(order, { buyFullCourse = false } = {}) {
  if (!order) return false;
  const orderId = String(order.order_id || "");
  if (orderId.startsWith("FREE_")) return true;

  const awaitingFullCourse =
    buyFullCourse || order?.metadata?.buy_full_course === true;
  if (awaitingFullCourse && orderId && !orderId.startsWith("FREE_")) {
    return false;
  }

  const amount = Number(order.amount_paid);
  return (
    order.payment_status === "success" ||
    (!Number.isNaN(amount) && amount < 1)
  );
}

export function razorpayAmountPaise(order, fallbackPrice) {
  const pending = Number(order?.metadata?.pending_amount);
  if (!Number.isNaN(pending) && pending >= 1) {
    return Math.round(pending * 100);
  }
  const paid = Number(order?.amount_paid);
  if (!Number.isNaN(paid) && paid >= 1) {
    return Math.round(paid * 100);
  }
  return Math.round(Number(fallbackPrice || 0) * 100);
}

export function isBuyFullCourseQuery(value) {
  return value === "1" || value === "true";
}
